module.exports = __webpack_public_path__ + "img/smart-scan-6.c5f6b8ef.png";